import { useCallback, useMemo } from "react";
import Select, {
  SelectOption,
  SelectProps,
} from "@/components/shared/select/Select";
import { Simulator } from "./simulator.model";
import { SimulatorChannelIcon } from "@/routes/simulators/SimulatorChannelIcon";

function buildSimulatorSelectOptions(
  simulators: Simulator[],
  size?: SelectProps["size"]
): SelectOption[] {
  const iconSize = size === "small" ? "1" : "2";

  return simulators.map((simulator) => ({
    label: simulator.name,
    value: String(simulator.id),
    icon: <SimulatorChannelIcon channel={simulator.channel} size={iconSize} />,
  }));
}

interface SelectSimulationProps
  extends Omit<SelectProps, "value" | "onChange" | "options" | "startIcon"> {
  value?: Simulator["id"];
  onChange: (value: Simulator["id"]) => void;
  simulators?: Simulator[];
}

export function SelectSimulation(props: SelectSimulationProps) {
  const value = props.value ? String(props.value) : undefined;

  const options = useMemo<SelectOption[]>(() => {
    return buildSimulatorSelectOptions(props.simulators ?? [], props.size);
  }, [props.simulators, props.size]);

  const onChange = useCallback(
    (value: string) => {
      props.onChange(Number(value));
    },
    [props.onChange]
  );

  return (
    <Select {...props} options={options} value={value} onChange={onChange} />
  );
}
